import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Layout from './components/layout/Layout';
import Home from './pages/Home';
import RealEstateApi from './pages/ApiDocs/RealEstateApi';
import BusinessApi from './pages/ApiDocs/BusinessApi';
import CardApi from './pages/ApiDocs/CardApi';
import Pricing from './pages/Pricing';
import Dashboard from './pages/Dashboard';
import GettingStarted from './pages/Support/GettingStarted';
import NotFound from './pages/NotFound';

function App() {
  return (
    <Router>
      <Layout>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/api-docs/realestate" element={<RealEstateApi />} />
          <Route path="/api-docs/business" element={<BusinessApi />} />
          <Route path="/api-docs/card" element={<CardApi />} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/support/getting-started" element={<GettingStarted />} />
          <Route path="/support/faq" element={<div className="min-h-screen flex items-center justify-center"><h1 className="text-3xl font-bold">FAQ 페이지 (개발 예정)</h1></div>} />
          <Route path="/support/community" element={<div className="min-h-screen flex items-center justify-center"><h1 className="text-3xl font-bold">커뮤니티 페이지 (개발 예정)</h1></div>} />
          <Route path="/developer-tools/api-test" element={<div className="min-h-screen flex items-center justify-center"><h1 className="text-3xl font-bold">API 테스트 콘솔 (개발 예정)</h1></div>} />
          <Route path="/developer-tools/sandbox" element={<div className="min-h-screen flex items-center justify-center"><h1 className="text-3xl font-bold">샌드박스 (개발 예정)</h1></div>} />
          <Route path="/developer-tools/sdk" element={<div className="min-h-screen flex items-center justify-center"><h1 className="text-3xl font-bold">SDK 다운로드 (개발 예정)</h1></div>} />
          <Route path="/developer-tools/code-samples" element={<div className="min-h-screen flex items-center justify-center"><h1 className="text-3xl font-bold">코드 샘플 (개발 예정)</h1></div>} />
          <Route path="/signup" element={<div className="min-h-screen flex items-center justify-center"><h1 className="text-3xl font-bold">회원가입 페이지 (개발 예정)</h1></div>} />
          <Route path="/login" element={<div className="min-h-screen flex items-center justify-center"><h1 className="text-3xl font-bold">로그인 페이지 (개발 예정)</h1></div>} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Layout>
    </Router>
  );
}

export default App;
